/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DetailedLogHits} from '../models/DetailedLogHits';
import type {Error} from '../models/Error';
import type {UserLogsPage} from '../models/UserLogsPage';
import type {UserLogsPageRequest} from '../models/UserLogsPageRequest';

export interface GetUserLog$Request {
    userId: number;
    userLogsPageRequest: UserLogsPageRequest;
}

export interface GetUserLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLogRequest = createAction<PayloadData<void, GetUserLog$Request>>('USER_LOG__GET_USER_LOG__REQUEST');
export const getUserLogSuccess = createAction<PayloadData<UserLogsPage, GetUserLog$Request>>('USER_LOG__GET_USER_LOG__SUCCESS');
export const getUserLogFailure = createAction<PayloadData<Error, GetUserLog$Request, true>>('USER_LOG__GET_USER_LOG__FAILURE');

export const getUserLogActions = [
    getUserLogRequest,
    getUserLogSuccess,
    getUserLogFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLogsPageRequest} meta.userLogsPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLog = (meta: GetUserLog$Request, config?: GetUserLog$Config) => {
    return {
        CALL_API: {
            types: getUserLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/change-logs`,
            TRANSPORT_REQUEST_BODY: meta.userLogsPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserLogById$Request {
    logId: string;
}

export interface GetUserLogById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLogByIdRequest = createAction<PayloadData<void, GetUserLogById$Request>>('USER_LOG__GET_USER_LOG_BY_ID__REQUEST');
export const getUserLogByIdSuccess = createAction<PayloadData<DetailedLogHits, GetUserLogById$Request>>('USER_LOG__GET_USER_LOG_BY_ID__SUCCESS');
export const getUserLogByIdFailure = createAction<PayloadData<Error, GetUserLogById$Request, true>>('USER_LOG__GET_USER_LOG_BY_ID__FAILURE');

export const getUserLogByIdActions = [
    getUserLogByIdRequest,
    getUserLogByIdSuccess,
    getUserLogByIdFailure
] as const;

/**
 * @param {string} meta.logId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLogById = (meta: GetUserLogById$Request, config?: GetUserLogById$Config) => {
    return {
        CALL_API: {
            types: getUserLogByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/change-log/${meta.logId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

